import { Button, Checkbox, CheckboxField, Loader, Typography } from '@finam/web-ui-kit';
import React from 'react';
import { getBase64 } from '../../filesHelper';
import { WebService } from '../../Services/WebService';
import { TokenContext } from '../../TokenContext';
import FileField from '../Fields/FileField';
import './Steps.scss';
import cn from 'classnames'
import FIASField, { IFIASValue } from '../Fields/FIASField';
import { IFiasAdress } from '../../Services/ResponseData';
import BankAccountField from '../Fields/BankAccountField';
import IFieldInfo from '../Data/IFieldInfo';

interface IState {
    fields: IFieldInfo[];
    isLoading: boolean;
    nextFileId: number;
    isUploadError: boolean;

    fiasRerenderKey1: number;
    fiasRerenderKey2: number;

    adressesSame: boolean;
    adressReal?: { [level: number]: IFiasAdress };
    initAdressReal?: string,
    initAdressOfficial?: string;
    adressOfficial?: { [level: number]: IFiasAdress };
    adressChanged?: boolean;

    bankAccountValue?: { bankId: number, account: string }
    bankAccountChanged?: boolean;
}



interface IProps {
    onError: (short: string, full: string) => void
    isClient: boolean
}


export default class DocumentsUploadStep extends React.Component<IProps, IState>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;

    constructor(props: any) {
        super(props);
        this.state = {
            adressesSame: false,
            fiasRerenderKey1: 0,
            fiasRerenderKey2: 0,
            fields: [],
            isLoading: true,
            nextFileId: 1,
            isUploadError: false
        }
    }

    private uploadFieldDoc(type: number, files: FileList | null): void {
        if (!files || !type)
            return;
        var newFields = [...this.state.fields];
        var fieldIndex = newFields.findIndex(v => v.nnDocType == type);
        var existsFiles = [...newFields[fieldIndex].files];
        Array.from(files).forEach(file =>
            existsFiles.push({ fileName: file.name, file: file, fileId: this.state.nextFileId }));
        newFields[fieldIndex].files = existsFiles;
        this.setState(prevState => ({ fields: newFields, nextFileId: prevState.nextFileId + 1 }));
    }


    private async uploadDocs(): Promise<void> {
        this.setState({ isLoading: true });
        var fields = [...this.state.fields];
        var dataPromises = fields.map(async (fld) => {
            const filesToUpload = fld.files?.filter(f => !!f.file);
            if (filesToUpload.length > 0) {
                var filesData: { file64: string, fileName: string }[] = [];
                var filesPromises = fld.files.map(async (file) => {
                    if (file.file) {
                        const data = await getBase64(file.file);
                        filesData.push({ file64: data.data, fileName: file.fileName });
                    }
                });
                await Promise.all(filesPromises);
                await new WebService(this.context.token).PostFileInfo({ items: filesData, nnDoc: fld.nnDoc, strDocCode: fld.strDocCode });
            }
        });
        Promise.all(dataPromises).then(res => this.InitFields())
            .catch(ex => { this.setState({ isLoading: false, isUploadError: true }); this.props.onError('Ошибка при загрузке документов', ''); this.InitFields(); });
    }

    private async saveAdress(): Promise<void> {
        if (!!this.state.adressReal && !!this.state.adressReal[0]) {
            const adressR = Object.values<IFiasAdress>(this.state.adressReal)
            new WebService(this.context.token).SaveFiasAdress(0, adressR);
        }
        const adressOff = this.state.adressesSame ? this.state.adressReal : this.state.adressOfficial;
        if (!!adressOff && !!adressOff[0]) {
            const adress = Object.values<IFiasAdress>(adressOff)
            new WebService(this.context.token).SaveFiasAdress(1, adress);
        }
    }

    componentDidMount(): void {
        this.InitFields();
        this.InitAdress();
    }

    private InitFields(): void {
        this.setState({ isLoading: true });
        new WebService(this.context.token).GetPersonalDocuments().then((pDocs) => {
            const fields: IFieldInfo[] = pDocs.map(d => ({
                fieldTitle: d.fieldName,
                files: d.files || [],
                nnDoc: d.nnDoc,
                nnDocType: d.nnDocType,
                strDocCode: d.strDocCode,
                isRequired: d.isRequired,
                description: d.description
            }));
            this.setState({ isLoading: false, fields: fields });
        });
    }

    private InitAdress(): void {
        const ws = new WebService(this.context.token);
        ws.GetFiasAdress(0).then(res => this.setState({ initAdressOfficial: res.address }));
        ws.GetFiasAdress(1).then(res => this.setState({ initAdressReal: res.address }));
    }

    private get AdressFields(): JSX.Element {
        return <div className='adresses'>
            <FIASField
                label='Адрес проживания'
                rerenderKey={`adressOff_${this.state.fiasRerenderKey1}`}
                value={this.state.adressReal}
                onValueChange={(val) => this.setState({ adressReal: val, fiasRerenderKey1: Math.random(), adressChanged: true })}
                initAdress={this.state.initAdressReal}
            />
            <CheckboxField
                className="sameAdressCheckbox"
                label="Адрес регистрации совпадает с адресом проживания"
                checked={this.state.adressesSame}
                onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => { this.setState({ adressesSame: checked, adressChanged: true }) }}
            />
            {!this.state.adressesSame && <FIASField
                label='Адрес регистрации'
                rerenderKey={`adressReg_${this.state.fiasRerenderKey2}`}
                value={this.state.adressOfficial}
                onValueChange={(val) => this.setState({ adressOfficial: val, fiasRerenderKey2: Math.random(), adressChanged: true })}
                initAdress={this.state.initAdressOfficial}
            />}
            <div style={{ paddingTop: '10px' }}>
                <Button
                    size='small'
                    onClick={() => { this.saveAdress() }}
                    disabled={!this.state.adressChanged}
                >Сохранить адрес</Button>
            </div>
        </div>
    }



    render() {
        const filesAlreadyDownload = this.state.fields.findIndex(fld => fld.files.findIndex(fl => !fl.file) > -1) > -1;
        return <div className='uploadStep'>
            {this.props.isClient && <Typography variant='caption12' className='clientWarning'>
                <b>Внимание!</b> Вы являетесь клиентом Финам, поэтому перед продолжением оформления, пройдите, пожалуйста, в личный кабинет на портале <a target="_blank" rel="noopener noreferrer" href='https://lk.finam.ru/'>finam.ru</a> и проверьте все ли ваши данные там верны.
            </Typography>}
            <Typography variant='h2' className='step-title'>Загрузите документы из перечня ниже</Typography>
            <Typography variant='caption11' className={cn('step-description', { 'step-error': this.state.isUploadError })}>Сумарный размер загруженных в <b>одно поле</b> документов не может превышать 15 Мб. Загрузите в несколько шагов если необходимо. </Typography>
            {
                this.state.isLoading ? <Loader /> :
                    <div className='document-form'>
                        <div className='document-form__Fields'>
                            {this.state.fields.filter(f => f.nnDocType != 3760).map((fi, i) => {
                                if (fi.nnDocType == 3991)
                                    return <div key={fi.nnDocType}>
                                        <FileField
                                            isRequired={fi.isRequired}
                                            files={fi.files && fi.files.map(f => ({ name: f.fileName, id: f.fileId, isNew: !!f.file }))}
                                            label={`${i + 1}. ${fi.fieldTitle}`}
                                            nnDoc={fi.nnDoc}
                                            onChange={(v) => { this.uploadFieldDoc(fi.nnDocType, v) }}
                                            description={fi.description} />
                                        {this.AdressFields}
                                    </div>
                                else return <FileField
                                    isRequired={fi.isRequired}
                                    files={fi.files && fi.files.map(f => ({ name: f.fileName, id: f.fileId, isNew: !!f.file }))}
                                    label={`${i + 1}. ${fi.fieldTitle}`}
                                    nnDoc={fi.nnDoc}
                                    onChange={(v) => { this.uploadFieldDoc(fi.nnDocType, v) }}
                                    key={fi.nnDocType}
                                    description={fi.description} />
                            })}
                            <div className='bankAccount'>
                                <BankAccountField
                                    onSave={(val) => { new WebService(this.context.token).SaveCard(val.bankId, val.account) }}
                                />
                            </div>
                        </div>

                        <Button
                            color='primary'
                            onClick={() => { this.uploadDocs() }}
                        >Загрузить</Button>
                    </div>
            }
            {filesAlreadyDownload && <div><div className='step-description waitMessage'><p>Мы получили ваши документы, вы можете продолжить загрузку если необходимо, если будут какие-то вопросы мы с вами свяжемся.</p></div></div>}
        </div>;
    }
}